import SystemNotificationGenerator from 'scripts/domain/contracts/system_notification_generator';

export default function(context, notificationId) {
  context.scheduler.cancel(notificationId);
  context.stores.notifications.remove(notificationId);
  SystemNotificationGenerator.closeNotification(notificationId);
}
